import React, { Component } from 'react';
import { Modal, FormGroup, Col, Form, ControlLabel } from 'react-bootstrap';
import { StateOptionsList } from '../StateList';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

export default class DisplayRowAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      street: '',
      city: '',
      state: '',
      zipCode: '',
    };
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.formAddress = this.formAddress.bind(this);
  }

  handleAddressChange(event) {
    console.log(event);
  }

  formAddress() {
    const addressObject = this.state;
    const address = `${addressObject.street}, ${addressObject.city}, ${addressObject.state} ${addressObject.zipCode}`;
    return address;
  }

  render() {
    return (
      <tr>
        <td>
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            ''
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.value}
        </td>
        {this.props.edit && (
          <Modal show={this.props.edit}>
            <Modal.Header>
              <Modal.Title>{this.props.prettyName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal>
                <FormGroup controlId="formHorizontalStreet">
                  <Col componentClass={ControlLabel} sm={2}>
                    Street
                  </Col>
                  <Col sm={10}>
                    <input
                      type="text"
                      name="street"
                      id="formStreet"
                      onChange={this.props.handleChange}
                      placeholder="Enter street"
                      title="No empty values allowed"
                      value={this.props.streetValue}
                      className="form-control"
                    />
                  </Col>
                </FormGroup>

                <FormGroup controlId="formHorizontalCity">
                  <Col componentClass={ControlLabel} sm={2}>
                    City
                  </Col>
                  <Col sm={10}>
                    <input
                      type="text"
                      name="city"
                      id="formCity"
                      onChange={this.props.handleChange}
                      placeholder="Enter City"
                      title="No empty values allowed"
                      value={this.props.cityValue}
                      className="form-control"
                    />
                  </Col>
                </FormGroup>

                <FormGroup controlId="formHorizontalState">
                  <Col componentClass={ControlLabel} sm={2}>
                    State
                  </Col>
                  <Col sm={10}>
                    <select
                      name="state"
                      onChange={this.props.handleChange}
                      value={this.props.stateValue}
                      className="form-control"
                      required
                    >
                      <StateOptionsList />
                    </select>
                  </Col>
                </FormGroup>
                <FormGroup controlId="formZipCode">
                  <Col componentClass={ControlLabel} sm={2}>
                    Zip Code
                  </Col>
                  <Col sm={10}>
                    <input
                      type="number"
                      name="zipCode"
                      id="formZipCode"
                      onChange={this.props.handleChange}
                      placeholder="Enter Zip Code"
                      title="No empty values. Format: nnnnn or nnnnn-nnnn"
                      value={this.props.zipcodeValue}
                      className="form-control"
                    />
                  </Col>
                </FormGroup>
              </Form>

              <font className="mandatory">{this.props.errorString}</font>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                onClick={this.props.handleClose}
                type="button"
                className="btn modalButtons btn-primary"
              >
                Close
              </button>
              <button
                onClick={this.props.handleSave}
                type="button"
                className="btn modalButtons btn-success"
              >
                Save
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </tr>
    );
  }
}
